import { useEffect, useRef } from "react";
import { ADSENSE_CLIENT } from "../ads/adsense";

declare global {
  interface Window { adsbygoogle?: unknown[] }
}

// A single AdSense ad unit. Renders nothing until ADSENSE_CLIENT + slot are configured,
// so the layout never shows an empty placeholder before approval.
export function AdSlot({ slot, className = "", style }: { slot: string; className?: string; style?: React.CSSProperties }) {
  const pushed = useRef(false);
  useEffect(() => {
    if (!ADSENSE_CLIENT || !slot || pushed.current) return;
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); pushed.current = true; } catch { /* loader not present */ }
  }, [slot]);

  if (!ADSENSE_CLIENT || !slot) return null;
  return (
    <ins className={"adsbygoogle " + className}
      style={{ display: "block", ...style }}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true" />
  );
}
